//------------------------
// remove rune skill adjs
//------------------------
export default function removeRuneSkillAdjs({ rune_name, skill_adjs } = {}) {
  console.log('-----------------------')
  console.log('IN removeRuneSkillAdjs')
  //---------------------------------------------------------------------
  // remove detailed skill adjs for given rune name
  //   e.g. +1 My Darkness Runecasting Adj
  //---------------------------------------------------------------------
  if (!rune_name || !Array.isArray(skill_adjs)) {
    console.error('removeRuneSkillAdjs: missing required parms')
    return skill_adjs
  }
  //-----------------------------------------------------
  // loop skill adjs backwards to enable safe removal
  //-----------------------------------------------------
  for (let j = skill_adjs.length - 1; j >= 0; j--) {
    const a = skill_adjs[j]
    //---------------------------------------------
    // match by rune name / rune field / adj_reason
    //---------------------------------------------
    if (
      a?.name === rune_name ||
      a?.rune === rune_name ||
      (typeof a?.adj_reason === 'string' && a.adj_reason.includes(rune_name))
    ) {
      //--------------------------------
      // remove adj from detailed array
      //--------------------------------
      skill_adjs.splice(j, 1)
    }
  }

  return skill_adjs
}
